(function () {
  if (window.__enchlivingNotifyMeInit) return;
  window.__enchlivingNotifyMeInit = true;

  var SUCCESS_VISIBLE_MS = 4000;

  function showAlert(container, type, message) {
    var alerts = container.querySelector('[data-notify-me-alerts]');
    if (!alerts) return;
    alerts.innerHTML =
      '<p class="notify-me__' + type + '" role="' + (type === 'success' ? 'status' : 'alert') + '">' +
        message +
      '</p>';
  }

  function clearAlerts(container) {
    var alerts = container.querySelector('[data-notify-me-alerts]');
    if (alerts) alerts.innerHTML = '';
  }

  function setFieldsVisible(container, visible) {
    var fields = container.querySelector('[data-notify-me-fields]');
    if (fields) fields.style.display = visible ? '' : 'none';
  }

  function collapseDetails(container) {
    var details = container.querySelector('details.notify-me__details');
    if (details) details.open = false;
  }

  function bindForm(form) {
    if (form.__enchlivingNotifyBound) return;
    form.__enchlivingNotifyBound = true;

    var container = form.closest('[data-notify-me]');
    if (!container) return;

    var iframeName = form.getAttribute('target');
    if (!iframeName) return;

    var iframe = document.querySelector('iframe[name="' + iframeName + '"]');
    if (!iframe) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    var successMsg = container.getAttribute('data-success-message') || 'Thanks!';
    var errorMsg = container.getAttribute('data-error-message') || 'Something went wrong. Please try again.';

    var pendingSubmit = false;

    form.addEventListener('submit', function () {
      pendingSubmit = true;
      clearAlerts(container);
      if (submitBtn) submitBtn.disabled = true;
    });

    iframe.addEventListener('load', function () {
      if (!pendingSubmit) return;
      pendingSubmit = false;

      var url = '';
      try {
        url = iframe.contentWindow.location.href || '';
      } catch (e) {
        url = '';
      }

      console.info('[notify-me] iframe load url:', url);

      var ok = /contact_posted=true/i.test(url);

      if (ok) {
        setFieldsVisible(container, false);
        showAlert(container, 'success', successMsg);
        setTimeout(function () {
          clearAlerts(container);
          collapseDetails(container);
          setFieldsVisible(container, true);
          form.reset();
          if (submitBtn) submitBtn.disabled = false;
        }, SUCCESS_VISIBLE_MS);
      } else {
        showAlert(container, 'error', errorMsg);
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-notify-me] form.notify-me__form').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  var observer = new MutationObserver(bindAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
